import type { BaseUsecase } from '@usecases/base-usecase';
import type { VoiceMailDropOutput } from './voice-mail-drop.controller';

export type VoiceMailDropRequest = {
  call_sid: string;
  prerecorded_message_id: string;
};

export interface VoiceMailDropEventPublisher {
  publish(
    call_sid: string,
    prerecorded_message_id: string,
  ): Promise<VoiceMailDropOutput>;
}

export interface VoiceMailDropUsecase
  extends BaseUsecase<VoiceMailDropRequest, VoiceMailDropOutput> {
  run(request: VoiceMailDropRequest): Promise<VoiceMailDropOutput>;
}

export class VoiceMailDrop implements VoiceMailDropUsecase {
  constructor(private publisher: VoiceMailDropEventPublisher) {}

  async run(request: VoiceMailDropRequest): Promise<VoiceMailDropOutput> {
    return this.publisher.publish(
      request.call_sid,
      request.prerecorded_message_id,
    );
  }
}
